module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/gh-286f4413bbf14d667ea8cbb147279a4e.svg";